import { useEffect } from "react";

const useKeypress = (key: KeyboardEvent["key"], action) => {
  useEffect(() => {
    const onKeyup = (e: KeyboardEvent) => {
      if (e.key === key) action();
    };

    window.addEventListener("keyup", onKeyup);

    return () => window.removeEventListener("keyup", onKeyup);
  }, [key, action]);
};

export default useKeypress;
